import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { 
  FaGuitar, 
  FaArrowLeft,
  FaShareAlt,
  FaCopy,
  FaStar,
  FaCheck,
  FaChevronLeft,
  FaChevronRight,
  FaExpand,
  FaTimes,
  FaWhatsapp,
  FaFacebook,
  FaTwitter,
  FaTools,
  FaExclamationTriangle,
  FaSync,
  FaTags,
  FaMusic,
  FaPercent,
  FaBox,
  FaTruck,
  FaShieldAlt,
  FaHeadphones,
  FaShoppingCart,
  FaHeart,
  FaEye,
  FaRulerCombined,
  FaPaintBrush,
  FaBolt,
  FaPalette,
  FaGem,
  FaCrown,
  FaFire,
  FaTachometerAlt,
  FaAward,
  FaShippingFast,
  FaUndo,
  FaCertificate
} from "react-icons/fa";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

// Loading Component - Modern
const DetailLoading = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-950 py-12">
    <div className="max-w-7xl mx-auto px-4">
      <div className="animate-pulse">
        <div className="flex items-center gap-4 mb-8">
          <div className="h-10 w-10 bg-gradient-to-r from-gray-700 to-gray-800 rounded-xl"></div>
          <div className="h-6 bg-gradient-to-r from-gray-700 to-gray-800 rounded w-1/4"></div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="space-y-4">
            <div className="h-[500px] bg-gradient-to-br from-gray-800 via-gray-700 to-gray-800 rounded-2xl"></div>
            <div className="grid grid-cols-4 gap-3">
              {[1,2,3,4].map(i => (
                <div key={i} className="h-20 bg-gradient-to-r from-gray-700 to-gray-800 rounded-xl"></div>
              ))}
            </div>
          </div>
          <div className="space-y-6">
            <div className="h-10 bg-gradient-to-r from-gray-700 to-gray-800 rounded w-3/4"></div>
            <div className="flex gap-2">
              <div className="h-6 bg-gradient-to-r from-gray-700 to-gray-800 rounded w-20"></div>
              <div className="h-6 bg-gradient-to-r from-gray-700 to-gray-800 rounded w-16"></div>
            </div>
            <div className="space-y-3">
              <div className="h-4 bg-gradient-to-r from-gray-700 to-gray-800 rounded w-full"></div>
              <div className="h-4 bg-gradient-to-r from-gray-700 to-gray-800 rounded w-5/6"></div>
              <div className="h-4 bg-gradient-to-r from-gray-700 to-gray-800 rounded w-4/6"></div>
            </div>
            <div className="h-24 bg-gradient-to-r from-gray-700 to-gray-800 rounded-2xl"></div>
            <div className="flex gap-4">
              <div className="h-14 bg-gradient-to-r from-gray-700 to-gray-800 rounded-2xl w-1/2"></div>
              <div className="h-14 bg-gradient-to-r from-gray-700 to-gray-800 rounded-2xl w-1/2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

// Error Component - Modern
const DetailError = ({ error, onRetry }) => (
  <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-950 flex items-center justify-center px-4">
    <div className="text-center max-w-md bg-gradient-to-br from-gray-800/50 to-gray-900/50 backdrop-blur-sm rounded-2xl border border-gray-700/50 p-8">
      <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-red-500/20 to-red-600/10 rounded-2xl flex items-center justify-center border border-red-500/30">
        <FaExclamationTriangle className="text-red-400 text-3xl" />
      </div>
      <h2 className="text-2xl font-bold text-white mb-3">Gitar Bulunamadı</h2>
      <p className="text-gray-400 mb-6">
        {error || "Aradığınız gitar bulunamadı veya bir hata oluştu."}
      </p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <button
          onClick={onRetry}
          className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-blue-500 to-gray-600 hover:from-blue-600 hover:to-gray-700 text-white px-6 py-3 rounded-xl font-medium transition-all duration-300 shadow-lg hover:shadow-xl"
        >
          <FaSync />
          Tekrar Dene
        </button>
        <Link
          to="/gitarlar"
          className="inline-flex items-center justify-center gap-2 bg-gradient-to-r from-gray-800 to-gray-900 hover:from-gray-700 hover:to-gray-800 text-white px-6 py-3 rounded-xl font-medium transition-all duration-300 border border-gray-700/50"
        >
          <FaArrowLeft />
          Gitarlara Dön
        </Link>
      </div>
    </div>
  </div>
);

// Main Image Component - DÜZELTİLMİŞ
const MainImage = ({ images, guitarName, selectedImage, onSelectImage }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalSelectedImage, setModalSelectedImage] = useState(selectedImage);

  const handlePrev = (e) => {
    e.stopPropagation(); // Tıklama event'ini durdur
    const newIndex = selectedImage === 0 ? images.length - 1 : selectedImage - 1;
    onSelectImage(newIndex);
    setModalSelectedImage(newIndex);
  };

  const handleNext = (e) => {
    e.stopPropagation(); // Tıklama event'ini durdur
    const newIndex = selectedImage === images.length - 1 ? 0 : selectedImage + 1;
    onSelectImage(newIndex);
    setModalSelectedImage(newIndex);
  };

  const handleModalPrev = (e) => {
    e.stopPropagation();
    const newIndex = modalSelectedImage === 0 ? images.length - 1 : modalSelectedImage - 1;
    setModalSelectedImage(newIndex);
  };

  const handleModalNext = (e) => {
    e.stopPropagation();
    const newIndex = modalSelectedImage === images.length - 1 ? 0 : modalSelectedImage + 1;
    setModalSelectedImage(newIndex);
  };

  const handleOpenModal = (e) => {
    e.stopPropagation();
    setModalSelectedImage(selectedImage);
    setIsModalOpen(true);
  };

  if (!images || images.length === 0) {
    return (
      <div className="h-[400px] md:h-[500px] bg-gradient-to-br from-gray-800 via-gray-700 to-gray-900 rounded-2xl flex flex-col items-center justify-center p-8 border border-gray-700/50">
        <div className="relative">
          <FaGuitar size={80} className="text-gray-700 mb-4 md:size-[120px]" />
          <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-purple-500/10 blur-xl opacity-50"></div>
        </div>
        <p className="text-gray-500 text-center text-lg">Görsel bulunmuyor</p>
      </div>
    );
  }

  return (
    <>
      {/* Main Image Container */}
      <div className="relative group">
        <div className="relative h-[400px] md:h-[800px] rounded-2xl overflow-hidden border border-gray-700/50 group-hover:border-blue-500/30 transition-all duration-500">
          <div className="absolute inset-0 bg-gradient-to-br from-gray-900/20 via-gray-800/10 to-gray-900/20 z-10"></div>
          <img
            src={images[selectedImage]}
            alt={`${guitarName} - ${selectedImage + 1}`}
            className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
            onClick={handleOpenModal}
            style={{ cursor: 'zoom-in' }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-gray-900/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
        </div>
        
        {/* Navigation Arrows - DÜZELTİLDİ */}
        {images.length > 1 && (
          <>
            <button
              onClick={handlePrev}
              className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-gradient-to-r from-black/80 to-gray-900/80 backdrop-blur-md rounded-full flex items-center justify-center text-white transition-all opacity-0 group-hover:opacity-100 hover:scale-110 active:scale-95 border border-white/20 shadow-xl z-20"
              style={{ pointerEvents: 'auto' }}
            >
              <FaChevronLeft size={18} />
            </button>
            <button
              onClick={handleNext}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 bg-gradient-to-r from-black/80 to-gray-900/80 backdrop-blur-md rounded-full flex items-center justify-center text-white transition-all opacity-0 group-hover:opacity-100 hover:scale-110 active:scale-95 border border-white/20 shadow-xl z-20"
              style={{ pointerEvents: 'auto' }}
            >
              <FaChevronRight size={18} />
            </button>
          </>
        )}

        {/* Expand Button - DÜZELTİLDİ */}
        <button
          onClick={handleOpenModal}
          className="absolute bottom-4 right-4 w-12 h-12 bg-gradient-to-r from-black/80 to-gray-900/80 backdrop-blur-md rounded-full flex items-center justify-center text-white transition-all hover:scale-110 active:scale-95 border border-white/20 shadow-xl z-20"
          style={{ pointerEvents: 'auto' }}
        >
          <FaExpand size={16} />
        </button>

        {/* Image Counter */}
        {images.length > 1 && (
          <div className="absolute bottom-4 left-4 px-4 py-2 bg-gradient-to-r from-black/80 to-gray-900/80 backdrop-blur-md rounded-full text-white text-sm border border-white/20 shadow-xl z-20">
            {selectedImage + 1} / {images.length}
          </div>
        )}
      </div>

      {/* Thumbnails - DÜZELTİLDİ */}
      {images.length > 1 && (
        <div className="mt-4 grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 gap-3">
          {images.map((image, index) => (
            <button
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                onSelectImage(index);
              }}
              className={`relative aspect-square rounded-xl overflow-hidden border-2 transition-all duration-300 cursor-pointer ${
                selectedImage === index 
                  ? 'border-blue-500 scale-105 shadow-lg shadow-blue-500/20' 
                  : 'border-transparent opacity-70 hover:opacity-100 hover:scale-105 hover:border-gray-500/50'
              }`}
              style={{ pointerEvents: 'auto' }}
            >
              <img
                src={image}
                alt={`thumbnail ${index + 1}`}
                className="w-full h-full object-cover"
              />
              <div className={`absolute inset-0 transition-all ${
                selectedImage === index 
                  ? 'bg-gradient-to-br from-blue-500/10 to-transparent' 
                  : 'bg-gradient-to-br from-gray-900/30 to-transparent'
              }`} />
            </button>
          ))}
        </div>
      )}

      {/* Fullscreen Modal - DÜZELTİLDİ */}
      <AnimatePresence>
        {isModalOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-950 flex items-center justify-center p-4 backdrop-blur-sm"
            onClick={() => setIsModalOpen(false)}
          >
            {/* Close Button */}
            <button
              className="absolute top-4 right-4 text-white text-2xl p-3 hover:bg-white/10 rounded-full transition-colors z-50 bg-gradient-to-r from-black/80 to-gray-900/80 backdrop-blur-md border border-white/20 shadow-xl"
              onClick={(e) => {
                e.stopPropagation();
                setIsModalOpen(false);
              }}
              style={{ pointerEvents: 'auto' }}
            >
              <FaTimes size={20} />
            </button>
            
            <div 
              className="relative max-w-7xl w-full h-full" 
              onClick={(e) => e.stopPropagation()}
              style={{ pointerEvents: 'auto' }}
            >
              <div className="relative h-full rounded-2xl overflow-hidden border border-white/10">
                <img
                  src={images[modalSelectedImage]}
                  alt={`${guitarName} - fullscreen`}
                  className="w-full h-full object-contain"
                />
              </div>
              
              {images.length > 1 && (
                <>
                  {/* Modal Navigation Buttons */}
                  <button
                    onClick={handleModalPrev}
                    className="absolute left-4 top-1/2 -translate-y-1/2 w-14 h-14 bg-gradient-to-r from-white/20 to-white/10 backdrop-blur-md rounded-full flex items-center justify-center text-white border border-white/20 hover:bg-white/30 transition-all z-10 shadow-xl"
                    style={{ pointerEvents: 'auto' }}
                  >
                    <FaChevronLeft size={20} />
                  </button>
                  <button
                    onClick={handleModalNext}
                    className="absolute right-4 top-1/2 -translate-y-1/2 w-14 h-14 bg-gradient-to-r from-white/20 to-white/10 backdrop-blur-md rounded-full flex items-center justify-center text-white border border-white/20 hover:bg-white/30 transition-all z-10 shadow-xl"
                    style={{ pointerEvents: 'auto' }}
                  >
                    <FaChevronRight size={20} />
                  </button>
                  
                  {/* Dots Indicator */}
                  <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-3 z-10">
                    {images.map((_, index) => (
                      <button
                        key={index}
                        onClick={(e) => {
                          e.stopPropagation();
                          setModalSelectedImage(index);
                          onSelectImage(index);
                        }}
                        className={`w-3 h-3 rounded-full transition-all hover:scale-125 cursor-pointer ${
                          modalSelectedImage === index 
                            ? 'bg-white scale-125 shadow-lg shadow-white/50' 
                            : 'bg-white/50 hover:bg-white/70'
                        }`}
                        style={{ pointerEvents: 'auto' }}
                      />
                    ))}
                  </div>

                  {/* Modal Thumbnails */}
                  <div className="absolute bottom-20 left-1/2 -translate-x-1/2 flex gap-3 overflow-x-auto max-w-[90%] py-2 z-10">
                    {images.map((image, index) => (
                      <button
                        key={index}
                        onClick={(e) => {
                          e.stopPropagation();
                          setModalSelectedImage(index);
                          onSelectImage(index);
                        }}
                        className={`flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden transition-all border-2 cursor-pointer ${
                          modalSelectedImage === index 
                            ? 'border-blue-500 scale-110 shadow-lg shadow-blue-500/30' 
                            : 'border-transparent opacity-60 hover:opacity-100 hover:scale-105 hover:border-white/30'
                        }`}
                        style={{ pointerEvents: 'auto' }}
                      >
                        <img
                          src={image}
                          alt={`thumbnail ${index + 1}`}
                          className="w-full h-full object-cover"
                        />
                      </button>
                    ))}
                  </div>
                </>
              )}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

// Tag List Component - Modern
const TagList = ({ tags }) => {
  if (!tags || tags.length === 0) return null;

  return (
    <div className="mb-6">
      <div className="flex flex-wrap gap-2">
        {tags.map((tag, index) => (
          <span
            key={index}
            className="px-4 py-2 bg-gradient-to-r from-purple-500/10 via-purple-600/10 to-purple-700/10 text-purple-400 text-sm rounded-xl border border-purple-500/20 flex items-center gap-2 backdrop-blur-sm"
          >
            <FaTags size={12} />
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
};

// Specs Table Component - Modern Grid
const SpecsTable = ({ specs }) => {
  if (!specs || Object.keys(specs).length === 0) return null;

  const specGroups = [
    {
      title: "Temel Özellikler",
      icon: FaGuitar,
      specs: [
        { label: "Body", value: specs.body },
        { label: "Neck", value: specs.neck },
        { label: "Fretboard", value: specs.fretboard },
        { label: "Finish", value: specs.finish },
      ].filter(s => s.value)
    },
    {
      title: "Donanım",
      icon: FaTools,
      specs: [
        { label: "Bridge", value: specs.bridge },
        { label: "Pickups (Neck)", value: specs.pickupsNeck || specs.pickups_neck },
        { label: "Pickups (Bridge)", value: specs.pickupsBridge || specs.pickups_bridge },
        { label: "Tuners", value: specs.tuners },
        { label: "Strings", value: specs.strings },
      ].filter(s => s.value)
    },
    {
      title: "Ekstra Detaylar",
      icon: FaGem,
      specs: [
        { label: "Scale Length", value: specs.scaleLength },
        { label: "Frets", value: specs.frets },
        { label: "Controls", value: specs.controls },
        { label: "Weight", value: specs.weight },
        { label: "Year", value: specs.year },
        { label: "Country", value: specs.country },
        { label: "Case Included", value: specs.caseIncluded ? "Evet" : "Hayır" }
      ].filter(s => s.value)
    }
  ].filter(group => group.specs.length > 0);

  if (specGroups.length === 0) return null;

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <div className="p-3 bg-gradient-to-r from-blue-500/20 to-blue-600/10 rounded-xl">
          <FaMusic className="text-blue-400 text-xl" />
        </div>
        <h3 className="text-2xl font-bold text-white">Teknik Özellikler</h3>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {specGroups.map((group, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-gradient-to-br from-gray-800/50 via-gray-800/30 to-gray-900/50 backdrop-blur-sm rounded-2xl border border-gray-700/50 p-6"
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="p-2 bg-gradient-to-r from-gray-700 to-gray-800 rounded-lg">
                <group.icon className="text-gray-300 text-lg" />
              </div>
              <h4 className="text-lg font-bold text-white">{group.title}</h4>
            </div>
            
            <div className="space-y-4">
              {group.specs.map((spec, specIndex) => (
                <div key={specIndex} className="flex flex-col gap-1 p-3 bg-gradient-to-r from-gray-900/30 to-gray-800/30 rounded-xl border border-gray-700/30">
                  <div className="text-gray-400 text-sm font-medium">{spec.label}</div>
                  <div className="text-white font-medium">{spec.value}</div>
                </div>
              ))}
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

// Feature Cards - Yeni Eklendi


// Share Modal Component - Modern
const ShareModal = ({ isOpen, onClose, guitar }) => {
  const shareUrl = window.location.href;
  const shareText = `${guitar.name} - ${guitar.brand} gitarını inceleyin!`;

  const shareLinks = [
    {
      platform: "WhatsApp",
      icon: FaWhatsapp,
      color: "from-green-500 to-emerald-600",
      url: `https://wa.me/?text=${encodeURIComponent(shareText + " " + shareUrl)}`
    },
    {
      platform: "Facebook",
      icon: FaFacebook,
      color: "from-blue-600 to-blue-700",
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`
    },
    {
      platform: "Twitter",
      icon: FaTwitter,
      color: "from-sky-500 to-sky-600",
      url: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`
    }
  ];

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      // Daha modern bir bildirim
      const notification = document.createElement('div');
      notification.className = 'fixed top-4 right-4 bg-gradient-to-r from-green-500 to-emerald-600 text-white px-6 py-3 rounded-xl font-medium shadow-xl z-50 animate-in slide-in-from-right';
      notification.textContent = 'Link panoya kopyalandı!';
      document.body.appendChild(notification);
      setTimeout(() => notification.remove(), 3000);
    } catch (err) {
      console.error("Kopyalama hatası:", err);
    }
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 flex items-center justify-center p-4"
        onClick={onClose}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900/80 via-gray-800/80 to-gray-950/80 backdrop-blur-sm"></div>
        
        <motion.div
          initial={{ scale: 0.9, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.9, opacity: 0, y: 20 }}
          className="relative bg-gradient-to-br from-gray-800 via-gray-800/90 to-gray-900 rounded-2xl border border-gray-700/50 p-6 max-w-md w-full shadow-2xl"
          onClick={e => e.stopPropagation()}
        >
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-gradient-to-r from-blue-500/20 to-blue-600/10 rounded-lg">
                <FaShareAlt className="text-blue-400" />
              </div>
              <h3 className="text-xl font-bold text-white">Paylaş</h3>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-700/50 rounded-xl transition-colors"
            >
              <FaTimes className="text-gray-400 hover:text-white" />
            </button>
          </div>

          <div className="grid grid-cols-3 gap-3 mb-6">
            {shareLinks.map((link, index) => (
              <motion.a
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className={`bg-gradient-to-r ${link.color} text-white p-4 rounded-xl flex flex-col items-center justify-center gap-2 shadow-lg hover:shadow-xl transition-all`}
              >
                <link.icon size={24} />
                <span className="text-sm font-medium">{link.platform}</span>
              </motion.a>
            ))}
          </div>

          <div className="flex gap-2">
            <div className="flex-1 relative">
              <input
                type="text"
                readOnly
                value={shareUrl}
                className="w-full bg-gradient-to-r from-gray-700/50 to-gray-800/50 border border-gray-600/50 rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-blue-500/50 pr-10"
              />
              <button
                onClick={copyToClipboard}
                className="absolute right-2 top-1/2 -translate-y-1/2 p-2 text-gray-400 hover:text-white transition-colors"
                title="Kopyala"
              >
                <FaCopy />
              </button>
            </div>
            <button
              onClick={copyToClipboard}
              className="bg-gradient-to-r from-blue-500 to-gray-600 hover:from-blue-600 hover:to-gray-700 text-white px-6 py-3 rounded-xl font-medium transition-all shadow-lg hover:shadow-xl"
            >
              Kopyala
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

// Ana Gitar Detay Componenti - Modern Dark Tema
function GitarDetay() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [guitar, setGuitar] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(0);
  const [isFavorite, setIsFavorite] = useState(false);

  useEffect(() => {
    const fetchGuitar = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const docRef = doc(db, "guitars", id);
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          const data = { id: docSnap.id, ...docSnap.data() };
          setGuitar(data);
          
          // Favori kontrolü
          const favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
          setIsFavorite(favorites.includes(id));
          
          // Geçmişe ekle
          const history = JSON.parse(localStorage.getItem('viewedGuitars') || '[]');
          const newHistory = [...new Set([{ id, name: data.name, image: data.imageUrls?.[0], brand: data.brand }, ...history])].slice(0, 10);
          localStorage.setItem('viewedGuitars', JSON.stringify(newHistory));
        } else {
          setError("Gitar bulunamadı");
        }
      } catch (err) {
        console.error("Gitar yüklenirken hata:", err);
        setError("Gitar yüklenirken bir hata oluştu");
      } finally {
        setLoading(false);
      }
    };

    fetchGuitar();
  }, [id]);

  const handleRetry = useCallback(() => {
    window.location.reload();
  }, []);

  const handleContact = () => {
    const message = `Merhaba, ${guitar?.name} gitarı hakkında bilgi almak istiyorum.`;
    const phoneNumber = "905308648486";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleSelectImage = (index) => {
    setSelectedImage(index);
  };

  const toggleFavorite = () => {
    const favorites = JSON.parse(localStorage.getItem('favorites') || '[]');
    if (isFavorite) {
      const newFavorites = favorites.filter(favId => favId !== id);
      localStorage.setItem('favorites', JSON.stringify(newFavorites));
    } else {
      localStorage.setItem('favorites', JSON.stringify([...favorites, id]));
    }
    setIsFavorite(!isFavorite);
  };

  if (loading) return <DetailLoading />;
  if (error || !guitar) return <DetailError error={error} onRetry={handleRetry} />;

  const images = guitar.imageUrls || [];
  const stock = guitar.stock || 0;
  const price = guitar.price || 0;
  const originalPrice = guitar.originalPrice || price;
  const discount = originalPrice > price 
    ? Math.round(((originalPrice - price) / originalPrice) * 100)
    : 0;
  const tags = guitar.tags || [];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-950">
      {/* Share Modal */}
      <ShareModal
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        guitar={guitar}
      />

      {/* Üst Navigasyon */}
      <div className="relative z-10 bg-gradient-to-b from-gray-900/80 via-gray-900/60 to-transparent backdrop-blur-sm border-b border-gray-700/30">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <motion.button
              whileHover={{ x: -5 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => navigate(-1)}
              className="inline-flex items-center gap-3 px-5 py-3 bg-gradient-to-r from-gray-800/60 to-gray-900/60 backdrop-blur-sm text-gray-300 hover:text-white rounded-xl transition-all border border-gray-700/50 hover:border-gray-600/50 shadow-lg"
            >
              <FaArrowLeft />
              Geri Dön
            </motion.button>
            
            <div className="flex items-center gap-2">

              
              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                onClick={() => setIsShareModalOpen(true)}
                className="p-3 bg-gradient-to-r from-gray-800/60 to-gray-900/60 backdrop-blur-sm text-gray-400 hover:text-white rounded-xl transition-all border border-gray-700/50 hover:border-gray-600/50 shadow-lg"
              >
                <FaShareAlt />
              </motion.button>
            </div>
          </div>
        </div>
      </div>

      {/* Ana İçerik */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Üst Kısım */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-12">
          {/* Sol Taraf - ANA FOTOĞRAF */}
          <div>
            <MainImage 
              images={images} 
              guitarName={guitar.name}
              selectedImage={selectedImage}
              onSelectImage={handleSelectImage}
            />
          </div>

          {/* Sağ Taraf - Bilgiler */}
          <div className="space-y-8">
            {/* Marka ve Kategori */}
            <div className="flex items-center gap-3 flex-wrap">
              {guitar.brand && (
                <motion.span 
                  initial={{ scale: 0.9, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  className="px-5 py-2.5 bg-gradient-to-r from-blue-500/20 via-blue-600/10 to-blue-700/5 backdrop-blur-sm text-blue-400 text-sm rounded-xl border border-blue-500/30 flex items-center gap-2 shadow-lg"
                >
                  <FaCrown size={12} />
                  {guitar.brand}
                </motion.span>
              )}
              {guitar.category && (
                <motion.span 
                  initial={{ scale: 0.9, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ delay: 0.1 }}
                  className="px-5 py-2.5 bg-gradient-to-r from-gray-800/50 to-gray-900/50 backdrop-blur-sm text-gray-300 text-sm rounded-xl border border-gray-700/50"
                >
                  {guitar.category}
                </motion.span>
              )}
              {guitar.featured && (
                <motion.span 
                  initial={{ scale: 0.9, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  transition={{ delay: 0.2 }}
                  className="px-5 py-2.5 bg-gradient-to-r from-amber-500/20 via-amber-600/10 to-amber-700/5 backdrop-blur-sm text-amber-400 text-sm rounded-xl border border-amber-500/30 flex items-center gap-2 shadow-lg"
                >
                  <FaStar size={12} />
                  Öne Çıkan
                </motion.span>
              )}
            </div>

            {/* Başlık */}
            <motion.h1
              initial={{ y: 20, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              className="text-4xl lg:text-5xl font-bold text-white leading-tight"
            >
              {guitar.name}
            </motion.h1>

            {/* Kısa Açıklama */}
            {guitar.shortDescription && (
              <p className="text-gray-300 text-lg leading-relaxed">
                {guitar.shortDescription}
              </p>
            )}

            {/* Etiketler */}
            <TagList tags={tags} />

            {/* Fiyat ve Stok */}
            <div className="space-y-4">
              <div className="flex items-center gap-4 mb-2">
                <div className="flex items-baseline gap-3">
                  <span className="text-4xl font-bold text-white">
                    {price.toLocaleString('tr-TR')} ₺
                  </span>
                  {discount > 0 && (
                    <motion.span 
                      initial={{ scale: 0 }}
                      animate={{ scale: 1 }}
                      className="bg-gradient-to-r from-red-500 to-pink-500 text-white text-sm font-bold px-4 py-2 rounded-full shadow-lg flex items-center gap-2"
                    >
                      <FaPercent size={12} />
                      %{discount} İNDİRİM
                    </motion.span>
                  )}
                </div>
              </div>
              {originalPrice > price && (
                <div className="text-gray-500 text-xl line-through">
                  {originalPrice.toLocaleString('tr-TR')} ₺
                </div>
              )}
              <div className={`text-lg ${stock > 0 ? 'text-green-400' : 'text-red-400'}`}>
                {stock > 0 ? (
                  <span className="inline-flex items-center gap-3 bg-gradient-to-r from-green-500/10 to-emerald-600/5 backdrop-blur-sm px-5 py-3 rounded-xl border border-green-500/30">
                    <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse" />
                    <FaCheck />
                    <span className="font-medium">Stokta - {stock} adet</span>
                  </span>
                ) : (
                  <span className="inline-flex items-center gap-3 bg-gradient-to-r from-red-500/10 to-red-600/5 backdrop-blur-sm px-5 py-3 rounded-xl border border-red-500/30">
                    <div className="w-3 h-3 bg-red-500 rounded-full" />
                    <span className="font-medium">SATILDI</span>
                  </span>
                )}
              </div>
            </div>

            {/* İletişim Butonları */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4">
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={handleContact}
                className="bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white py-4 rounded-2xl font-bold transition-all duration-300 flex items-center justify-center gap-3 text-lg shadow-xl hover:shadow-2xl"
              >
                <FaWhatsapp size={22} />
                WhatsApp ile İletişim
              </motion.button>
              
              <motion.button
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="bg-gradient-to-r from-gray-800 to-gray-900 hover:from-gray-700 hover:to-gray-800 text-white py-4 rounded-2xl font-bold transition-all duration-300 flex items-center justify-center gap-3 text-lg border border-gray-700/50"
                onClick={() => window.scrollTo({ top: document.querySelector('.specs-section')?.offsetTop, behavior: 'smooth' })}
              >
                <FaEye size={20} />
                Tüm Özellikleri İncele
              </motion.button>
            </div>
          </div>
        </div>

        {/* Ürün Açıklaması */}
        {guitar.description && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="mb-12"
          >
            <div className="bg-gradient-to-br from-gray-800/50 via-gray-800/30 to-gray-900/50 backdrop-blur-sm rounded-2xl border border-gray-700/50 p-8">
              <div className="flex items-center gap-4 mb-8">
                <div className="p-3 bg-gradient-to-r from-blue-500/20 to-blue-600/10 rounded-xl">
                  <FaPaintBrush className="text-blue-400 text-xl" />
                </div>
                <h3 className="text-2xl font-bold text-white">Ürün Açıklaması</h3>
              </div>
              <div className="prose prose-invert max-w-none">
                <p className="text-gray-300 leading-relaxed text-lg whitespace-pre-line">
                  {guitar.description}
                </p>
              </div>
            </div>
          </motion.div>
        )}

        {/* Teknik Özellikler */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-12 specs-section"
        >
          <SpecsTable specs={guitar.specs} />
        </motion.div>

        {/* Geri Dönüş Butonu */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-12 pt-8 border-t border-gray-800/50 text-center"
        >
          <Link
            to="/gitarlar"
            className="inline-flex items-center gap-4 bg-gradient-to-r from-gray-800 to-gray-900 hover:from-gray-700 hover:to-gray-800 text-white px-8 py-4 rounded-2xl font-bold transition-all duration-300 border border-gray-700/50 text-lg shadow-lg hover:shadow-xl"
          >
            <FaArrowLeft />
            Tüm Gitarları Görüntüle
          </Link>
        </motion.div>
      </div>
    </div>
  );
}

export default GitarDetay;